import { motion, useScroll, useTransform } from 'framer-motion';
import { useRef } from 'react';
import { Link } from 'react-router-dom';

/**
 * Massive BRAVO wordmark that fills the viewport, parallax on scroll.
 * Acts as a visual closing statement before the footer.
 */
export default function MegaBravoBanner() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  });
  const x = useTransform(scrollYProgress, [0, 1], [-60, 60]);
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.85, 1], [0, 1, 1, 0.4]);

  return (
    <section
      ref={ref}
      className="relative bg-[#050505] py-20 sm:py-28 lg:py-40 overflow-hidden"
      data-testid="mega-bravo-banner"
    >
      {/* Grain */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.04] mix-blend-overlay"
        style={{
          backgroundImage:
            'url("data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%22120%22 height=%22120%22><filter id=%22n%22><feTurbulence type=%22fractalNoise%22 baseFrequency=%220.9%22 numOctaves=%222%22 stitchTiles=%22stitch%22/></filter><rect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23n)%22/></svg>")',
        }}
      />

      <motion.div style={{ x, opacity }} className="relative z-10 px-4">
        <h2
          className="select-none text-center text-[20vw] sm:text-[18vw] lg:text-[16vw] font-black leading-[0.78] tracking-tighter uppercase"
          style={{
            fontFamily: "'Unbounded', sans-serif",
            background: 'linear-gradient(180deg, #F5D25A 0%, #D4AF37 50%, #6b5311 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}
        >
          BRAVO
        </h2>
      </motion.div>

      <div className="relative z-10 text-center mt-6 sm:mt-10 px-4">
        <p
          className="text-xs sm:text-sm uppercase tracking-[0.4em] text-white/40 max-w-md mx-auto leading-relaxed"
          style={{ fontFamily: "'Manrope', sans-serif" }}
        >
          Creamos el Momento Euge.
        </p>
        <Link
          to="/eventos"
          className="inline-flex mt-8 items-center gap-3 text-[#D4AF37] hover:text-[#F5D25A] text-sm font-extrabold uppercase tracking-[0.25em] transition-colors"
          style={{ fontFamily: "'Unbounded', sans-serif" }}
          data-testid="mega-explore-cta"
        >
          Explorar eventos →
        </Link>
      </div>
    </section>
  );
}
